export enum RoutesPageSteps {
  ClerkLogin = "Clerk Login",
  CreditCheckPermission = "Credit Check Permission",
  CustomerContactInfo = "Customer Contact Info",
  CustomerRegistration = "Customer Registration",
  EnterDeviceTag = "Enter Device Tag",
  IdUpload = "ID Upload",
  IncodeIdUpload = "Incode ID Upload",
  MerchantLogin = "Merchant Login",
  Offers = "Offers",
  PrivacyPolicy = "Privacy Policy",
  DateOfBirthVerification = "Date of Birth Verification",
  IdNumberDobVerification = "ID Number and DOB Verification",
  Receipt = "Receipt",
  SoftwareInstallation = "Software Installation",
  TermsAndConditions = "Terms and Conditions",
  WaitForIdValidation = "Wait for ID validation",
  Welcome = "Welcome",
  WelcomeCall = "Welcome Call",
}
